import CustomButton from "components/CustomButton/CustomButton";
import DialogAlertAction from "components/DialogAlertAction/DialogAlertAction";

const DialogConfirmExitWithoutSaving = ({
    dialog, 
    updateActivityPopup
}) => {
    function confirmExit() {
        dialog.hide();
        updateActivityPopup.popup.hide();
    }
    return (
        <DialogAlertAction
            show={dialog.value}
            toggleShow={dialog.toggle}
            width="700px"
            widthContent="100%"
            variant="secondary"
            title="¿Deseas salir sin guardar los cambios?"
            content="Recuerda que si no guardas los cambios, estos se perderán y deberás registrarlos nuevamente.">
            <CustomButton 
                variant="secondary" 
                text="No, cancelar"
                width="120px"
                onClick={dialog.hide}/>
            <CustomButton 
                text="Sí, salir"
                width="120px"
                onClick={confirmExit}/>
        </DialogAlertAction>
    );
}

export default DialogConfirmExitWithoutSaving;